export const User = ({ id, roleIds, locationIds, email, lastName, firstName }) => (
  {
    id: id,
    role_ids: roleIds ?? [],
    location_ids: locationIds ?? [],
    email: email,
    last_name: lastName,
    first_name: firstName,
    password_confirmation: '',
    password: '',
  }
)
